// src/components/StapKaart.js
// Eén stap van een doorloopje als kaart in de stappen-grid: afbeelding, nummer, titel en daaronder
// de inhoud (children). Gedeeld door het doorloopje in de app en de publieke voorvertoning.
import React from 'react';

function StapKaart({ nummer, titel, afbeelding, alt, children }) {
  return (
    <div className="step-card">
      <div className="step-card-image-container">
        {afbeelding ? (
          <>
            <div className="step-card-image-background" style={{ backgroundImage: `url(${afbeelding})` }}></div>
            <img src={afbeelding} alt={alt} className="step-card-image-foreground" />
          </>
        ) : (
          <div className="step-card-image-placeholder"></div>
        )}
      </div>
      <div className="step-card-content">
        <span className="step-number">{nummer}</span>
        <div className="step-description">
          {titel && <h4>{titel}</h4>}
          {children}
        </div>
      </div>
    </div>
  );
}

export default StapKaart;
